/**
 * @typedef {import('modules/notifications/types').NotificationStatus} NotificationStatus
 *
 * @typedef {{
 *   [key in NotificationStatus]: NotificationStatus
 * }} NotificationsStatuses
 */

import { EXTENSIONS_ENUM } from './ExtensionConstants';

/** @type {NotificationsStatuses} */
export const STATUSES = {
  READ: 'READ',
  UNREAD: 'UNREAD'
};

export const MOBILE_CHANNEL_EXTENSIONS = [
  EXTENSIONS_ENUM.AFTER_SALES,
  EXTENSIONS_ENUM.AUDIT,
  EXTENSIONS_ENUM.CHAT,
  EXTENSIONS_ENUM.PARTS,
  EXTENSIONS_ENUM.SALES,
  EXTENSIONS_ENUM.SELF_SERVICE
];
